import React, { useRef } from "react";
import Service from '../../service/Service';
const service = new Service();
// import * as actions from '../Actions';

export default function AnswerOverlay({ eleRef }) {

    let queIdRef = useRef(null);
    let titleRef = useRef(null);
    let userIdRef = useRef(null);
    let answerRef = useRef(null);

     var handlePostAnswer = () => {

        let answer = answerRef.current?.value || '';

        if (answer.trim() === '') {
            eleRef.setState({ answerError: 'Please write answer' });
            return;
        } else {
            eleRef.setState({ answerError: '' });
            postCommentAnswer({ queIdRef, titleRef, userIdRef,answerRef }, eleRef);
        }
    };

    const postCommentAnswer = (payload, eleRef) => {

        let pic_url = eleRef?.state?.userPhoto || "";
        let username = eleRef?.state?.firstname;
        let userchildList = eleRef?.state?.auth_Data?.childData?.UserChildList;
        let expecting_dob = '';

        if(eleRef.state?.auth_data?.childData?.UserChildList[0].IsExpected == 1) {
            expecting_dob = eleRef.state?.auth_data?.childData?.UserChildList[0].DOB;
        }else{
            expecting_dob = '';
        }
        let question_creater_id = payload.userIdRef.current?.value || "";

        let postArr ={
            "question_id":payload.queIdRef.current?.value,
            "pic_url":pic_url,
            "user_name":username,
            "childinfo":userchildList,
            "answer_type":0,
            "question_type":1,
            "que_type":"child",
            "question_creater_id":question_creater_id,
            "answer_details":payload.answerRef.current?.value,
            "expecting_dob":expecting_dob,
            "user_type":global.userAry['Sex']
        }

        let url = global.api_ci_url + "api/fetchfromCI/postAnswer";

        service.postServiceCall(url, postArr)
        .then((res) => {
            // console.log("API response:", res);
            closeAnswerOverlay();
        })
        .catch((err) => {
            console.error("API error:", err);

            eleRef.setState({ answerError: 'Something went wrong' });
        });
    };


    var closeAnswerOverlay = () => {
        document.getElementsByClassName('addAns-overlay')[0].style.display = 'none';
        document.getElementsByTagName('body')[0].style.overflow = 'visible';

        document.getElementById('post_answer_text').value = '';
        document.getElementById('answer_queId').value = '';
        document.getElementById('quation_title').value = '';
        document.getElementById('answer_queUserId').value = '';
        eleRef.setState({ answerError: '' });
        
    }
 
    return (
        <div className="addAns-overlay"  >
            <div className="addAns-popup">
                <div className="addAns-header expert-ansOverlay">
                    <span className="M18_48">Add An Answer</span>
                    <span className="closeButton icon" data-icon-font="C" onClick={closeAnswerOverlay}  ></span>
                    {/*  actions.domClick.bind(this); */}
                </div>
                <div className="write-comment-container">
                    <input type="hidden" id="answer_queId" ref={queIdRef}  />
                    <input type="hidden" id="quation_title" ref={titleRef} />
                    <input type="hidden" id="answer_queUserId" ref={userIdRef} />
                    <textarea id="post_answer_text" ref={answerRef} rows="4" cols="50" 
                    className="comment-box L14_74" 
                    onChange={() => {
                        if (eleRef?.state?.answerError) {
                            eleRef.setState({ answerError: '' });
                        }
                    }}
                    placeholder="Write your Answer here"></textarea>
                    {/* <div className="file_upload_err error_ans"></div> */}
                    {eleRef?.state?.answerError && (
                        <div className="file_upload_err_expert error_ans">
                            <span className="error">{eleRef.state.answerError}</span>
                        </div>
                    )}
                    <p className="b_1 right postcomment" id="devpostanswers" onClick={handlePostAnswer} >Post Answer</p>
                     
                </div>
            </div>
        </div>
    );
}

